import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/saga-blue/theme.css';

const header = () => (
    <h3 className="p-col-12 p-md-12 text-center">
        <i className="pi pi-user" />Identity Details
    </h3>);

const footer = () => (
    <div className="p-grid" style={{ flex: 3 }}>
          <div style={{ flex: 1 }}>
               <Button className="p-button-text" label="Back" />
          </div>
          <div style={{ flex: 1 }}>
            <center> 
              <Button className="p-button-secondary"   style={{ flex: 1 }} label="Save" />
            </center>
          </div>
          <div style={{ flex: 1 }}>
          <Button className="pull-right" label="Next" />
          </div>
        </div>
    // <div className="p-grid">
    //     <div className="p-col-12 p-md-5">
    //         <Button className="p-button-text" label="Back" />
    //     </div>
    //     <div className="p-col-12 p-md-2">
    //         <Button className="p-button-secondary" label="Save" />
    //     </div>
    //     <div className="p-col-12 p-md-3">
    //     </div>
    //     <div className="p-col-12 p-md-2">
    //         <Button className="pull-right" label="Next" />
    //     </div>
    // </div>
    );

function IdentityDetails() {
    return (
        <Card className="p-col-12 p-md-12"
            header={header}
            footer={footer}>
        </Card>
    );
}

export default IdentityDetails;
